
import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'

import { useTeams } from '@/Hooks/UseTeam'
import useTranslation from '@/Hooks/UseTranslation'

import InternalProfilesTab from './InternalProfilesTab/InternalProfilesTab'
import InviteByMailTab from './InviteByMailTab/InviteByMailTab'
import Modal from '../Modal/Modal'
import SearchUsersTab from './SearchUsersTab/SearchUsersTab'

import './TeamMembersSelector.scss'

interface Props {
  onHide?: () => void
}

const TeamMembersSelector = ({ onHide}: Props) => {

  const { t } = useTranslation()

  const { showTeamMembersSelector, setShowTeamMembersSelector } = useTeams()

  const [ tab, setTab ] = useState('existingUser')

  const cancel = () => {

    setShowTeamMembersSelector(false)

    onHide && onHide()
  }

  return (
    <Modal
      show={showTeamMembersSelector}
      title={t('TEAMMEMBER_SELECTOR:Title')}
      onClose={() => cancel()}
      showCloseButton={true}
    >
      <div className="team-members-selector">
        <Tabs
          variant="pills"
          className="teams-selector-nav"
          activeKey={tab}
          onSelect={(k: any) => setTab(k)}
        >
          <Tab eventKey="existingUser" title={t('TEAMMEMBER_SELECTOR:ExistingUser')}>
            <SearchUsersTab />
          </Tab>
          <Tab eventKey="byMail" title={t('TEAMMEMBER_SELECTOR:ByMail')}>
            <InviteByMailTab />
          </Tab>
          <Tab eventKey="internalProfile" title={t('TEAMMEMBER_SELECTOR:InternalProfile')}>
            <InternalProfilesTab />
          </Tab>
        </Tabs>
      </div>
    </Modal>
  )
}

export default TeamMembersSelector
